// Suppress noisy third-party internal deprecation warnings before modules evaluate
if (typeof window !== 'undefined') {
  window.addEventListener('error', e => {
    if (e.message === 'Script error.' || e.message === 'ResizeObserver loop limit exceeded') {
      e.stopImmediatePropagation();
    }
  });

  const originalWarn = console.warn;
  console.warn = function(...args) {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('The `css` function is deprecated') ||
       args[0].includes('styleFunctionSx'))
    ) {
      return;
    }
    originalWarn.apply(console, args);
  };
}
